export const TRANSACTION_STATUS_POLLING_INTERVAL = 2000;
